// IMPORTANT: this MUST be the very first import in the bundle. It installs
// `window.error` / `unhandledrejection` listeners on module evaluation so
// that an error thrown by any subsequent top-level import (FirebaseUtils,
// Capacitor plugin init, lazy chunks, …) is forwarded to native logs and
// shown to the user as a recoverable fallback screen instead of leaving
// the Android WebView blank.
import "./services/GlobalErrorHandler";
import "reflect-metadata";
import React from "react";
import ReactDOM from "react-dom";
import {datadogLogs} from "@datadog/browser-logs";
import "./i18n";
import App from "./App";
import "./styles/ws/index.css";
import ColorSchemeService from "services/ColorSchemeService";
import {getLocalDB, functions, httpsCallableCustom, isAndroid} from "FirebaseUtils";
import LocalStorageService from "services/LocalStorageService.js";
import {LOCAL_STORAGE_KEYS} from "constants/AppConstants.js";
import TokenService from "services/TokenService.js";
import {awaitFirebaseReady} from "services/FirebaseDbService";

TokenService.configureMapkitTokenFetcher(async (addOrigin) => {
  const getMapkitJsToken = httpsCallableCustom(functions, "getMapkitJsToken");
  const result = await getMapkitJsToken({origin: window.location.origin});
  return result.data.token;
});

getLocalDB().then((r) => console.log("DB fully initialized !"));

ColorSchemeService.init();

try {
  const clientToken = process.env.REACT_APP_DATADOG_CLIENT_TOKEN;
  const isDatadogEnabled = false;
  if (clientToken && isAndroid && isDatadogEnabled) {
    datadogLogs.init({
      clientToken: clientToken,
      site: process.env.REACT_APP_DATADOG_SITE || "datadoghq.com",
      service: process.env.REACT_APP_DATADOG_SERVICE || "waterspeed-capacitor",
      env: process.env.REACT_APP_DATADOG_ENV,
      version: process.env.REACT_APP_VERSION,
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
      beforeSend: ((event: any) => {
        // make sure the user_id is on the root of the event
        try {
          const user = datadogLogs.getUser ? datadogLogs.getUser() : null;
          const uid = (user && user.id) || LocalStorageService.get(LOCAL_STORAGE_KEYS.uid);
          if (uid) {
            event.user_id = uid;
          }
        } catch (e) {
          // ignore
        }
      }) as any
    });

    // Attach initial user context if available
    try {
      const uid = LocalStorageService.get(LOCAL_STORAGE_KEYS.uid);
      if (uid) {
        datadogLogs.setUser({id: uid, user_id: uid});
      }
    } catch (e) {
      // ignore
    }
  }
} catch (e) {
  // Best-effort init; do not block app start
  // eslint-disable-next-line no-console
  console.error("Datadog Logs init failed", e);
}

// FirebaseDbService assigns its bindings asynchronously (it cannot use top-level
// await). Render only once that has settled, so nothing reads `isAndroid` while it
// is still the default false and takes the web path on Android. Resolves even if
// init failed, so a broken config still renders and surfaces the error.
void awaitFirebaseReady().then(() => {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById("root")
  );
});
